<script setup lang="ts">
import { type Component } from "vue";
import { Popover, PopoverButton, PopoverPanel } from "@headlessui/vue";

import { Button, Dots } from "@/components/global";
import { type ButtonVariant } from "@/components/global/Button.vue";

export interface TableActionButton {
  id: string;
  label: string;
  icon: Component | string; 
  action: () => void;
  view?: boolean;
  variant?: ButtonVariant;
  disabled?: boolean;
  loading?: boolean;
}

defineProps<{
  menu: TableActionButton[];
}>();
</script>

<template>
  <Popover class="position-relative">
    <PopoverButton as="div">
      <Dots />
    </PopoverButton>

    <PopoverPanel
      class="popover-panel panel-left"
      style="padding: 0.5rem 0.625rem; width: max-content; max-width: 13rem; border-radius: 5px;"
    >
      <div class="d-flex flex-column" style="gap: 0.25rem 0;">
        <Button
          v-for="button in menu"
          :key="button.id"
          @click.stop="button.action"
          :test-id="`${button.id}-action-btn`"
          :variant="button?.variant"
          :disabled="button?.disabled"
          size="sm"
          class="justify-content-start"
          style="padding: 0.625rem 0.75rem;"
        >
          <component :is="button.icon" style="width: 1rem; height: 1rem;" />
          
          <span style="margin-left: 0.25rem;">{{ button.label }}</span>

          <output v-if="button?.loading" class="ms-1 spinner-border spinner-border-sm"></output>
        </Button>
      </div>
    </PopoverPanel>
  </Popover>
</template>
